import { render } from "./ModalBody.vue?vue&type=template&id=09b74e4b&scoped=true&ts=true"
import script from "./ModalBody.vue?vue&type=script&lang=ts"
export * from "./ModalBody.vue?vue&type=script&lang=ts"

import "./ModalBody.vue?vue&type=style&index=0&id=09b74e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b74e4b"]])

export default __exports__